import { Component } from '@angular/core';
import { MainLayoutComponent } from './layout';

@Component({
    selector: 'lpcr-app-root',
    template: `<lpcr-app-main-layout />`,
    imports: [MainLayoutComponent]
})
export class AppComponent  {
}
